import React from "react";
import { Button } from "@material-ui/core";
import { Typography } from "common";
import { SVGDocumentSingle } from "images/SVGDocumentSingle";

export function RateConfirmationButton({ onClick }) {
  return (
    <Button size="small" color="primary" startIcon={<SVGDocumentSingle />} onClick={onClick}>
      <Typography color="primary" value="Rate Confirmation" />
    </Button>
  );
}
